import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrow-pointer-down",
  "use": "svg_arrow-pointer-down-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 16\" id=\"svg_arrow-pointer-down\"><path d=\"m7 12.17 3.59-3.59L12 10l-6 6-6-6 1.41-1.41L5 12.17V0h2z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol